import { Theme, Typography } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import { memo } from 'react'
import BankLogo from '../../decorators/bank-logo-with-rating/BankLogo'
import { IImgColor } from '../../decorators/bank-logo-with-rating/typings'

import { IAddress } from './typings'

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    addressContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingLeft: 20,
      paddingTop: 20,
      [theme.breakpoints.down('md')]: {
        borderRight: 'none',
        margin: '10px 20px',
        paddingLeft: 10,
        paddingTop: 20,
      },
    },
    headerText: {
      fontWeight: '700',
      fontSize: 18,
      margin: '10px 0',
      [theme.breakpoints.down('md')]: {
        marginTop: 20,
      },
    },
    microTextCls: {
      fontSize: 12,
      marginTop: 10,
      color: theme.palette.grey[600],
    },
  }),
)

const Address = ({ address, logos }: IAddress) => {
  const { addressContainer, headerText, microTextCls } = useStyles()
  const logoSrc = {
    [IImgColor.COLOR]: logos.colorSVG,
    [IImgColor.GREY]: logos.graySVG,
  }

  return (
    <div className={addressContainer}>
      <Typography className={headerText}>Online-Kredit von</Typography>
      <BankLogo
        logoSrc={logoSrc}
        customSizing={{
          height: '50px',
          width: '150px',
        }}
      />
      <Typography className={microTextCls}>{address}</Typography>
    </div>
  )
}

export default memo(Address)
